import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.css";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretLeft } from "@fortawesome/free-regular-svg-icons";

type ToggleSidebarButtonProps = {
  isCollapsed: boolean;
  toggleAside: () => void;
};

const ToggleSidebarButton: React.FC<ToggleSidebarButtonProps> = ({ isCollapsed, toggleAside }) => {
  return (
    <button
      type="button"
      onClick={toggleAside}
      className="sidebar-toggle-btn z-10"
      style={{
        position: "fixed",
        top: "1rem",
        left: isCollapsed ? "1rem" : "calc(18rem - 1.5rem)",
        transform: isCollapsed ? "none" : "translateX(-50%)",
      }}
      aria-label={isCollapsed ? "Menü öffnen" : "Menü schließen"}
    >
      <FontAwesomeIcon icon={isCollapsed ? faBars : faSquareCaretLeft} className="sidebar-toggle-icon" />
    </button>
  );
};

export default ToggleSidebarButton;
